document.addEventListener('DOMContentLoaded', function() {
  const additionalModal = document.querySelector('#AdditionalBundleProductModal');
  if (!additionalModal) return;

  function applyAdditionalSelection(targetDropdown, productItem) {
    if (!targetDropdown || !productItem) return false;

    const variantId = productItem.getAttribute('data-product-variant-id');
    if (!variantId) return false;

    const selectedProduct = productItem.querySelector('.product-bundle__product-info__description[data-description="list"]')?.textContent.trim();
    const productImage = productItem.querySelector('.cart-item__image');

    targetDropdown.setAttribute('data-type', 'selected');
    targetDropdown.setAttribute('data-product-variant-id', variantId);
    targetDropdown.setAttribute('data-checked', 'true');

    const dropdownImage = targetDropdown.querySelector('.product-bundle__product-image img');
    if (dropdownImage && productImage) {
      dropdownImage.src = productImage.src;
      dropdownImage.classList.remove('default_image');
    }

    const titleElement = targetDropdown.querySelector('[data-selected-product]');
    if (titleElement && selectedProduct) {
      titleElement.textContent = selectedProduct;
    }

    targetDropdown.querySelectorAll('.product-bundle__product-info__description').forEach(desc => desc.style.display = 'none');
    targetDropdown.querySelector('[data-description="selected"]')?.style.setProperty('display', 'block');

    return true;
  }

  additionalModal.addEventListener('click', function(e) {
    const productItem = e.target.closest('.ed-product-bundle__product[data-type="list"]');

    if (productItem && productItem.hasAttribute('data-add-variant')) {
      e.preventDefault();

      const currentItem = additionalModal.dataset.currentItem;

      const targetDropdown = document.querySelector(
        `.additional-bundle-section .ed-product-bundle__product[data-current="${currentItem}"]`
      );

      if (applyAdditionalSelection(targetDropdown, productItem)) {
        additionalModal.removeAttribute('open');
        document.body.classList.remove("overflow-hidden");
        document.dispatchEvent(new CustomEvent("modalClosed"));

        document.querySelector('product-bundle')?.updateAddToCartButton?.();
        checkAllSelectionsAndEnableCart();
      }
    }
  });

  function preselectAdditionalOptions() {
    additionalModal.dataset.currentItem = '1';

    const fallbackProduct = additionalModal.querySelector('.ed-product-bundle__product[data-type="list"][data-add-variant]');
    if (!fallbackProduct) return;

    const additionalDropdowns = document.querySelectorAll('.additional-bundle-section .ed-product-bundle__product[data-type="additional"]');
    if (additionalDropdowns.length === 0) return;

    additionalDropdowns.forEach((dropdown) => {
      applyAdditionalSelection(dropdown, fallbackProduct);
    });

    checkAllSelectionsAndEnableCart();
  }

  function checkAllSelectionsAndEnableCart() {
    document.querySelector('product-bundle')?.updateAddToCartButton?.();
  }

  preselectAdditionalOptions();

  setTimeout(() => {
    const bundleComponent = document.querySelector('product-bundle');
    if (!bundleComponent) return;

    const originalIsValidCartAdd = bundleComponent._isValidCartAdd.bind(bundleComponent);
    bundleComponent._isValidCartAdd = function() {
      const baseValid = originalIsValidCartAdd();

      const additionalDropdowns = document.querySelectorAll('.additional-bundle-section [data-type="additional"]');
      const additionalSelected = document.querySelectorAll('.additional-bundle-section [data-type="selected"]');

      if (additionalDropdowns.length > 0) {
        return baseValid && (additionalSelected.length === additionalDropdowns.length);
      }

      return baseValid;
    };

    const originalCollectItems = bundleComponent._collectItems.bind(bundleComponent);
    bundleComponent._collectItems = function() {
      const items = originalCollectItems();
      const useShekoCartTransform = this.configuration.enable_sheko_cart_transform !== false;
      const enableLegacyCheckoutExtension = this.configuration.enable_checkout_extension === true;
      const enableLegacyBundleV2 = this.configuration.enable_checkout_extension_v2 === true;

      const additionalSelections = document.querySelectorAll('.additional-bundle-section [data-type="selected"]');
      const componentTemplate = items.find((item) =>
        item.properties?._shekoBundleId || item.properties?._edBundleId
      );
      const bundleId = componentTemplate?.properties?._shekoBundleId
        || componentTemplate?.properties?._edBundleId
        || globalThis.crypto?.randomUUID?.()
        || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      const parentVariantId = componentTemplate?.properties?._shekoBundleParentVariantId
        || componentTemplate?.properties?._edBundleParentVariantId
        || this.configuration.id;
      const bundleSku = componentTemplate?.properties?._bundleSku
        || this.configuration.sku
        || '';

      additionalSelections.forEach((item, index) => {
        const variantId = item.getAttribute('data-product-variant-id');

        if (variantId) {
          const existingItem = useShekoCartTransform
            ? null
            : items.find((cartItem) => cartItem.id === parseInt(variantId));

          if (existingItem) {
            existingItem.quantity += parseInt(this.quantity.value);
          } else {
            const newItem = {
              quantity: parseInt(this.quantity.value),
              id: parseInt(variantId),
              properties: {
                _bundle: "item",
                _token: this.configuration.token,
                _hash: this.configuration.hash,
                _checkout_hidden: true,
                _bundle_type: 'additional',
                _bundle_group: 'abnehmkur'
              }
            };

            if (useShekoCartTransform) {
              newItem.properties._edBundleId = bundleId;
              newItem.properties._edBundleParentVariantId = parentVariantId;
              newItem.properties._shekoBundleId = bundleId;
              newItem.properties._shekoBundleParentVariantId = parentVariantId;
              newItem.properties._shekoBundleComponentId = `${bundleId}-additional-${index + 1}`;
              newItem.properties._edBundlePrice = this.configuration.ed_bundle_price;
              newItem.properties._edBundleQuantity = parseInt(this.quantity.value);
              newItem.properties._bundleSku = bundleSku;
              newItem.properties._handle = this.configuration.handle;
            } else if (enableLegacyCheckoutExtension) {
              newItem.properties._edBundleId = bundleId;
              newItem.properties._edBundleParentVariantId = parentVariantId;
              newItem.properties._edBundlePrice = this.configuration.ed_bundle_price;
              newItem.properties._edBundleQuantity = parseInt(this.quantity.value);
              newItem.properties._bundleSku = bundleSku;
              newItem.properties._handle = this.configuration.handle;
            }

            if (useShekoCartTransform || !enableLegacyBundleV2) {
              items.push(newItem);
            }
          }

          const masterItem = items.find(item => item.properties && item.properties._bundle === 'master');
          if (masterItem) {
            const selectedProductName = item.querySelector('[data-selected-product]')?.textContent.trim();
            if (selectedProductName) {
              if (!masterItem.properties._selected) {
                masterItem.properties._selected = [];
              }
              masterItem.properties._selected.push(selectedProductName);

              if (!masterItem.properties._bundleInfo[variantId]) {
                masterItem.properties._bundleInfo[variantId] = 0;
              }
              masterItem.properties._bundleInfo[variantId] += parseInt(this.quantity.value);

              masterItem.properties._bundleItemCount += parseInt(this.quantity.value);

              if (masterItem.properties._edBundleItems) {
                const currentIds = masterItem.properties._edBundleItems.split(',');
                currentIds.push(variantId);
                masterItem.properties._edBundleItems = currentIds.join(',');
              }
            }
          }
        }
      });

      return items;
    };
  }, 500);
});
